export const  capitalizeFirstLetter = (text: string) =>{
    return text?.charAt(0).toUpperCase() + text?.slice(1);
}

export const  capitalizeLetters = (text: string) =>{
    return text.toLowerCase().split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}